import lrDate from './_src/lrDate.vue'

lrDate.install = function(Vue) {
  Vue.component(lrDate.name, lrDate)
}

export default lrDate